"use client";

import { c as _c } from "react/compiler-runtime";
import { RiGraduationCapLine } from "react-icons/ri";
import { ProgressLine } from "@/components/ui/progress-line";
import { nextOpenTask } from "@/lib/training";
import { useTraining } from "@/api/provider/training/training-query";
import { openTrainingSidebar } from "@/features/sidebar/training-sidebar";

/** Footer card for a sandbox trainee: progress, and the next task. Opens the Training panel. */
export function SidebarTrainingCard() {
  const $ = _c(18);
  const {
    data
  } = useTraining();
  if (!data?.available || !data.plan) {
    return null;
  }
  const total = data.totals.open + data.totals.done + data.totals.skipped;
  const settled = data.totals.done + data.totals.skipped;
  if (total === 0) {
    return null;
  }
  let t0;
  if ($[0] !== data) {
    t0 = nextOpenTask(data);
    $[0] = data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const next = t0;
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <RiGraduationCapLine className="size-3.5 shrink-0 self-center" aria-hidden="true" />;
    t2 = <span className="shrink-0 font-semibold">Training</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  const t3 = `${settled} / ${total}`;
  let t4;
  if ($[4] !== t3) {
    t4 = <span className="flex items-baseline gap-2 pl-0.5 pr-1 text-caption">{t1}{t2}<span className="flex-1 truncate text-right tabular-nums text-foreground-secondary">{t3}</span></span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `Training: ${settled} of ${total} tasks done or skipped`;
  let t6;
  if ($[6] !== settled || $[7] !== t5 || $[8] !== total) {
    t6 = <ProgressLine done={settled} total={total} label={t5} />;
    $[6] = settled;
    $[7] = t5;
    $[8] = total;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== next) {
    t7 = next ? <>{"Next: "}<span className="text-foreground">{next.task.title}</span></> : "All done";
    $[10] = next;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <span className="line-clamp-2 pl-0.5 pr-1 text-caption text-foreground-secondary">{t7}</span>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t4 || $[15] !== t6 || $[16] !== t8) {
    t9 = <button type="button" onClick={openTrainingSidebar} className="mb-2 ml-4 mr-2 flex flex-col gap-2 rounded-lg border border-border bg-background p-2.5 text-left text-foreground transition-colors duration-200 hover:bg-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary motion-reduce:transition-none">{t4}{t6}{t8}</button>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}